import { render, staticRenderFns } from "./OpenAuthorizationTab.vue?vue&type=template&id=7fae5e5a&scoped=true"
import script from "./OpenAuthorizationTab.vue?vue&type=script&lang=js"
export * from "./OpenAuthorizationTab.vue?vue&type=script&lang=js"
import style0 from "./OpenAuthorizationTab.vue?vue&type=style&index=0&id=7fae5e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fae5e5a",
  null
  
)

export default component.exports